import React, {FC, useEffect} from 'react';
import texts from '../../../texts';
import {NextState} from '../../../types';
import {useFooterContext} from '../../../hooks';
import {SuccessComponent} from '../../../Components/SuccessComponent';
import {useFiscalYear} from '../../../hooks/useFiscalYear';

export const FinishedStep: FC = () => {
    const footerState = useFooterContext();
    const [fiscalYearStateLoaded, fiscalYearState] = useFiscalYear();

    useEffect(() => {
        if (footerState.onNextState === NextState.Processing) {
            footerState.setOnNextState(NextState.Done);
        }
    }, [footerState.onNextState]);

    useEffect(() => {
        footerState.setFiscalYearEndDate(
            fiscalYearStateLoaded ? fiscalYearState?.prevEndDate : undefined
        );
    }, [fiscalYearStateLoaded]);

    return (
        <SuccessComponent
            title={texts['stage0_step4_title']}
            subtitle={texts['stage0_step4_prompt']}
        />
    );
};
